import { Band } from '@/components/Modules/Band/Band';
import { useViewport } from '@zopauk/react-components';
import { TelephoneCard } from '@/components/TelephoneCard';
import type { FinancialHelpFragment } from '@/utils/dato/generated';

const MOBILE_BREAKPOINT = 768;

const FinancialHelp = ({ contactInformation, preamble, heading }: FinancialHelpFragment) => {
  const { width } = useViewport();
  const isMobile = (width ?? 0) <= MOBILE_BREAKPOINT;

  return (
    <Band background="#E4F9F1" contained={true}>
      <div className="px-5 mx-auto max-w-[648px]">
        {heading || preamble ? (
          <div className="text-center">
            {heading ? (
              <h2 className="text-4xl lg:text-5xl my-4 font-serif font-semibold mb-5 lg:mb-6">{heading}</h2>
            ) : null}
            {preamble ? <p className="mb-8 lg:mb-9">{preamble}</p> : null}
          </div>
        ) : null}
        {contactInformation.map((provider) => {
          let link = provider.telephoneLink || '';

          if (!isMobile && provider?.url) {
            link = provider?.url;
          }

          return (
            <TelephoneCard
              telephoneText={provider.telephoneText || ''}
              description={provider.openingHours}
              title={provider.title || ''}
              telephoneLink={link}
              key={provider.url}
            />
          );
        })}
      </div>
    </Band>
  );
};

export default FinancialHelp;
